import * as $ from 'jquery';
import {Global} from '../init-global';
import 'slick-carousel';
import Event = JQuery.Event;
import {Observable, Subscription, Subscriber} from "rxjs";


export class Product {

    protected $window: JQuery;
    protected $root: JQuery;

    protected $content: JQuery;
    protected $carouselWrapper: JQuery;
    protected $carouselNav: JQuery;
    protected $scrollNext: JQuery;
    protected $scrollPrev: JQuery;
    protected loading: Subscription;
    protected timeoutLoadingID:any;
    protected timeoutLoadedID:any;

    constructor(elem: HTMLElement)
    {
        this.$window  = $(<any>window);
        this.$root    = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
        this.$content         = $('.js-product__content', this.$root);
        this.$carouselWrapper = $('.l-product-banner__list', this.$root);
        this.$scrollNext      = $('.l-product-banner__scroll-item--right button', this.$root);
        this.$scrollPrev      = $('.l-product-banner__scroll-item--left button', this.$root);
        this.initCarousel();
    };

    private initCarousel = () => {
        this.$carouselWrapper.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 800,
            nextArrow: this.$scrollNext,
            prevArrow: this.$scrollPrev,
            rows: 0
        });
        this.$carouselWrapper.on({
            beforeChange: this.handleLoading,
            afterChange: this.handleLoaded
        })
    };

    private handleLoading = (ev:Event, slick:JQuerySlick, current:number, next:number) => {
        this.$content.addClass('l-product-content--loading');
        let observable = new Observable((subscriber:Subscriber<string>) => this.loadProductContent(subscriber, slick, next));
        this.loading = observable.subscribe((rawResponse:any) => {
            let response = JSON.parse(rawResponse);
            if (undefined !== response.html) {
                this.$content.html(response.html);
            }
        });
    };

    private handleLoaded = () => {
        if (this.loading.closed) {
            this.showProductContent();
        } else {
            this.loading.add(() => this.showProductContent());
        }
    };

    private loadProductContent = (observer:Subscriber<string>, slick:JQuerySlick, loading:number) => {
        let action = 'yeoldeoak/product_get_content';
        let id = $(slick.$slides[loading]).data('id');
        $.ajax({
            url:(<any>window).params.ajax_url,
            method: 'POST',
            data: {
                'action': action,
                'id': id
            }
        }).done((response) => {
            observer.next(response);
            observer.complete();
        });
    };

    private showProductContent = () => {
        if (typeof this.timeoutLoadingID != 'undefined') clearTimeout(this.timeoutLoadingID);

        this.timeoutLoadingID = setTimeout(() => {
            this.$content.addClass('l-product-content--loaded');

            if (typeof this.timeoutLoadedID != 'undefined') clearTimeout(this.timeoutLoadedID);
            this.timeoutLoadedID = setTimeout(() => {
                this.$content.removeClass('l-product-content--loading l-product-content--loaded');
                clearTimeout(this.timeoutLoadedID);
            }, 100);

            clearTimeout(this.timeoutLoadingID);
        }, 600);
    }
}